var _effectorFileName = "/src/widgets/layouts/main/components/sidebar/sidebar.tsx";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ExternalLinkIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'next-i18next';
import HamburgerIcon from '@/shared/components/icons/hamburger-icon';
import { LanguageSwitcher } from '@/shared/components/language-switcher';
import { ThemeToggle } from '@/shared/components/theme-toggle';
import { Button } from '@/shared/components/ui/button';
import { Separator } from '@/shared/components/ui/separator';
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from '@/shared/components/ui/sheet';
import { cn } from '@/shared/lib/cn';
export const Sidebar = () => {
  const {
    t
  } = useTranslation('layout-header');
  const pathname = usePathname();
  return <Sheet>
      <SheetTrigger asChild>
        <Button variant="secondary" size="icon-lg" aria-label={t('aria.openSidebar')}>
          <HamburgerIcon />
        </Button>
      </SheetTrigger>

      <SheetContent className="flex flex-col justify-between pl-8">
        <SheetTitle className="sr-only">{t('sidebar.title')}</SheetTitle>
        <SheetDescription className="sr-only">{t('sidebar.description')}</SheetDescription>

        <nav className="flex flex-col place-items-start py-10">
          <div className="flex w-full flex-col space-y-3">
            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/'
            })} href="/" aria-label={t('aria.home')}>
                {t('nav.home')}
              </Link>
            </SheetClose>

            <Separator className="mb-4 mt-2 w-full" />

            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/individual-lessons'
            })} href="/individual-lessons" aria-label={t('services.individual.aria')}>
                {t('services.individual.title')}
              </Link>
            </SheetClose>

            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/group-lessons'
            })} href="/group-lessons" aria-label={t('services.group.aria')}>
                {t('services.group.title')}
              </Link>
            </SheetClose>

            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/group-lessons'
            })} href="/pair-lessons" aria-label={t('services.pair.aria')}>
                {t('services.pair.title')}
              </Link>
            </SheetClose>

            <Separator className="mb-4 mt-2 w-full" />

            <SheetClose asChild>
              <Link className="flex items-center gap-1" href={process.env.NEXT_PUBLIC_B2B_URL ?? ''} target="_blank" rel="noopener noreferrer" aria-label={t('aria.forCompanies')}>
                <span>{t('nav.forCompanies')}</span>
                <ExternalLinkIcon className="ml-1 size-4" />
              </Link>
            </SheetClose>

            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/cases'
            })} href="/cases" aria-label={t('aria.cases')}>
                {t('nav.cases')}
              </Link>
            </SheetClose>

            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/teachers'
            })} href="/teachers" aria-label={t('aria.teachers')}>
                {t('nav.teachers')}
              </Link>
            </SheetClose>
          </div>
        </nav>

        <div>
          <Separator className="mb-4 mt-2 w-full" />
          <div className="flex items-center justify-between">
            <ThemeToggle withText={false} />

            <LanguageSwitcher />
          </div>
        </div>
      </SheetContent>
    </Sheet>;
};